export default __webpack_public_path__ + "static/media/werkschau_leonschmidt.01578068.png";